import { mergeStyleSets, getTheme } from "@fluentui/react";

const theme = getTheme();

const styles = mergeStyleSets({
  experimentOverview: {
    padding: "5px 10px",
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
    fontSize: "14px",
    color: theme.palette.neutralPrimary,
    width: "100%",
  },
  experimentOverviewNotSetText: {
    color: theme.palette.neutralSecondaryAlt,
    fontStyle: "italic",
  },
  experimentOverviewText: {
    fontWeight: "bold",
  },
  experimentOverviewDescription: {
    textAlign: "left",
    marginTop: "10px",
  },
  experimentFormLink: {
    color: theme.palette.themePrimary,
    textDecoration: "underline",
    background: "none",
    border: "none",
    padding: "0",
    font: "inherit",
    cursor: "pointer",
    transition: "color 0.2s",
    ":hover": {
      color: theme.palette.themeDark,
      outline: "none",
      textDecoration: "underline",
    },
    ":focus": {
      color: theme.palette.themeDark,
      outline: "none",
      textDecoration: "underline",
    },
  },
});

export { styles };
